module.exports = __webpack_public_path__ + "static/media/boek_07.62efb03b.png";